import script from "./qxdj_drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./qxdj_drawer.vue?vue&type=script&setup=true&lang=js"

import "./qxdj_drawer.vue?vue&type=style&index=0&id=917be17a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-917be17a"]])

export default __exports__